import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Stack,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { STATES } from '../../../../constants';

interface LocationFieldsProps {
  name: string;
  street_address_1: string;
  street_address_2: string;
  city: string;
  state: string;
  zip: string;
  onDelete?: () => void;
  showDelete?: boolean;
  onChange?: (field: string, value: string) => void;
  onBlur?: () => void;
  formErrors?: LocationFormErrors;
}

export interface LocationFormErrors {
  name: string | null;
  street_address_1: string | null;
  street_address_2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export default function LocationFields({
  name,
  street_address_1,
  street_address_2,
  city,
  state,
  zip,
  onDelete,
  showDelete = false,
  onChange,
  onBlur,
  formErrors = {
    name: null,
    street_address_1: null,
    street_address_2: null,
    city: null,
    state: null,
    zip: null,
  },
}: LocationFieldsProps) {
  const fieldWidth = 600;

  return (
    <Stack spacing={2}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          width: "100%"
        }}>
        <TextField
          label='Location Name *'
          value={name}
          onChange={(e) => onChange?.('name', e.target.value)}
          onBlur={() => onBlur?.()}
          variant="outlined"
          size="medium"
          fullWidth
          error={!!formErrors.name}
        />
        {showDelete && (
          <IconButton onClick={onDelete}>
            <Delete sx={{ color: (theme) => theme.palette.utilityIcon }} />
          </IconButton>
        )}
      </Stack>
      <TextField
        label="Address Line 1 *"
        value={street_address_1}
        onChange={(e) => onChange?.('street_address_1', e.target.value)}
        onBlur={() => onBlur?.()}
        variant="outlined"
        size="medium"
        fullWidth
        sx={{
          maxWidth: fieldWidth,
        }}
        error={!!formErrors.street_address_1}
      />
      <TextField
        label="Address Line 2"
        value={street_address_2}
        onChange={(e) => onChange?.('street_address_2', e.target.value)}
        variant="outlined"
        size="medium"
        fullWidth
        sx={{
          maxWidth: fieldWidth,
        }}
      />
      <Stack
        direction="row"
        spacing={1}
        sx={{ width: '100%', maxWidth: fieldWidth }}
      >
        <TextField
          label="City *"
          value={city}
          onChange={(e) => onChange?.('city', e.target.value)}
          onBlur={() => onBlur?.()}
          variant="outlined"
          size="medium"
          sx={{
            flex: 1,
          }}
          error={!!formErrors.city}
        />
        <FormControl sx={{ width: 200 }}>
          <InputLabel id="state-select-label">State</InputLabel>
          <Select
            labelId="state-select-label"
            value={state}
            onChange={(e) => onChange?.('state', e.target.value)}
            onBlur={() => onBlur?.()}
            label="State *"
            size="medium"
            error={!!formErrors.state}
          >
            <MenuItem value="" disabled>
              Select State
            </MenuItem>
            {STATES.map((stateName) => (
              <MenuItem key={stateName} value={stateName}>
                {stateName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Zip Code *"
          value={zip}
          onChange={(e) => onChange?.('zip', e.target.value)}
          onBlur={() => onBlur?.()}
          variant="outlined"
          size="medium"
          sx={{
            width: 100,
          }}
          error={!!formErrors.zip}
        />
      </Stack>
    </Stack>
  );
}